module.exports = __webpack_public_path__ + "static/media/B.4e7e9993.svg";